import { render, staticRenderFns } from "./tableImportStudent.vue?vue&type=template&id=1c6a6454&scoped=true&"
import script from "./tableImportStudent.vue?vue&type=script&lang=js&"
export * from "./tableImportStudent.vue?vue&type=script&lang=js&"
import style0 from "./tableImportStudent.vue?vue&type=style&index=0&id=1c6a6454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6a6454",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataFooter } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VChip,VDataFooter,VDataTable,VTextField})
